import React from 'react';
import {Grid, Typography, Input, Checkbox,Button, Radio, FormControl, FormLabel, RadioGroup, Select,MenuItem,InputLabel } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Slider from '@material-ui/core/Slider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {log} from 'mathjs';

class InputData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChange=(name,val)=>{
    this.setState({
      [name]:val
    })
  }

  submitData=()=>{
    this.props.onSubmit(this.state);

  }


  render() {
    return (
      <div>
        <Box border="3px solid gray">
          <Grid container direction="column" >
            <Row label="Age" input=<AgeSlider onChange = {this.onChange}></AgeSlider> desc="Years"></Row>
            <Row label="CA-125" input=<CA125Input onChange = {this.onChange}></CA125Input> desc= "(IU/mL)"></ Row>
    
            <Row
              label="Pelvic LN status"
              input=<PLNCheckbox onChange = {this.onChange} name = "pln"></PLNCheckbox>
              >
            </Row>

            <Row
              label="Primary treatment strategy"
              input=<NACCheckbox onChange = {this.onChange} name = "nac"></NACCheckbox>
              >
            </Row>

            <Row
              label="Small bowel and mesentery"
              input=<SBMCheckbox onChange = {this.onChange} name = "sbm"></SBMCheckbox>
              >
            </Row>

            <Row
              label="Other pelvic tissue except uterus and tube"
              input=<OPTCheckbox onChange = {this.onChange} name = "opt"></OPTCheckbox>
              >
            </Row>


          </Grid>
        </Box>
        <Grid container alignItems="flex-start" justify="flex-end" direction="row">
          <Button variant='contained' color='primary' onClick={this.submitData}>Submit</Button>
        </Grid>
      </div>

    );
  }
}

export default InputData;

class Row extends React.Component {
  render() {
    return(
      <Grid container
        direction="row"
        spacing={1}
        justify="flex-start"
        alignItems="center"
        >
          <Grid item xs={4}>
            <Typography>
              <Box fontWeight = "fontWeightBold" fontSize={15} ml={1}>
                {this.props.label}
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={6}>
            {this.props.input}
          </Grid>
          <Grid item xs={2}>
            <Typography>
              <Box fontSize={20}>
                {this.props.desc}
              </Box>
            </Typography>
          </Grid>
      </Grid>
    );
  }
}

class AgeSlider extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,e.target.value);
    if(isNaN(e.target.value)||parseFloat(e.target.value)<20||parseFloat(e.target.value)>100){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
  }
  render(){
    return (
      <Input
        onChange = {this.onChange('age')}
        fullWidth={true}
        placeholder="Range : 20 - 100"
        error={this.state.error}

      />
    );
  }
}

class UniformCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >No</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Yes</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}

class FIGOCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Stage I-II  </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Stage III-IV</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}

class RTSCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Complete cytoreduction </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Gross residual tumor</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}

class PLNCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >No involvement </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Involvement</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}
class NACCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,(e.target.value));
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >PDS</Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >NAC</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}

class CA125Input extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    this.props.onChange(name,log(e.target.value));
    if(isNaN(e.target.value)||parseFloat(e.target.value)<2.7||parseFloat(e.target.value)>45200){
      this.setState({error:true})
    }
    else{
      this.setState({error:false})
    }
  }
  render(){
    return (
        <Input
          onChange = {this.onChange('ca125')}
          fullWidth={true}
          placeholder="Range : 2.7 - 45200"
          error={this.state.error}
        />
    );
  }
}


class OPTCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    let val=e.target.value;
    if(val==0){
      this.props.onChange('opt1',0)
      this.props.onChange('opt2',0)
    }
    else if(val==1){
      this.props.onChange('opt1',1)
      this.props.onChange('opt2',0)
    }
    else{
      this.props.onChange('opt1',0)
      this.props.onChange('opt2',1)
    }
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box > No </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Microscopic </Box>
                </Typography>
              </div>
            />
          <FormControlLabel value="2" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Macroscopic</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}


class SBMCheckbox extends React.Component {
  constructor(props){
    super(props);
    this.state={error:false}
  }
  onChange = name =>(e) =>{
    let val=e.target.value;
    if(val==0){
      this.props.onChange('sbm1',0)
      this.props.onChange('sbm2',0)
    }
    else if(val==1){
      this.props.onChange('sbm1',1)
      this.props.onChange('sbm2',0)
    }
    else{
      this.props.onChange('sbm1',0)
      this.props.onChange('sbm2',1)
    }
  }
  render(){
    return (
      <FormControl  component="fieldset">
          <RadioGroup row aria-label="gender" name="gender1" onChange={this.onChange(this.props.name)}>
            <FormControlLabel value="0" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >No + Microscopic </Box>
                </Typography>
              </div>
            />
            <FormControlLabel value="1" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Macroscopic(≤ 2cm) </Box>
                </Typography>
              </div>
            />
          <FormControlLabel value="2" control={<Radio />} label=
              <div>
                <Typography display="inline">
                  <Box >Macroscopic (> 2cm)</Box>
                </Typography>
              </div>
            />
          </RadioGroup>
      </FormControl>

    );
  }
}
